var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-lg"},[_c('div',{staticClass:"row justify-between items-start"},[_c('h1',[_vm._v("Логи "),_c('span',{staticClass:"data-rows-number"},[_vm._v(_vm._s(_vm.totalLogs))])])]),_vm._v(" "),_c('logs-list')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ab4b4c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/LogsView.vue
// module id = HiM9
// module chunks = 0